
import Vue, {PropOptions} from 'vue'
import 'sharer.js/sharer.min.js';
import ChildView from '~/lib/types/ChildView';
import appConfig from '~/lib/util/appConfig';

// import selectElementContents
import {selectElementContents} from '~/lib/util/dom_utils';

// https://web.dev/articles/web-share?hl=pl
// https://developer.mozilla.org/en-US/docs/Web/API/Navigator/share
// https://stackoverflow.com/a/48095951/1637178 (fb-messenger://share/?link=)


export default Vue.extend({
  props: {
    child: {
      type: Object,
      required: true
    } as PropOptions<ChildView>
  },
  data() {
    return {
      // shareTitle: 'Kupuj i Pomagaj - {imie i nazwisko}!',
      shareTitle: 'Kupuj i Pomagaj!',
      shareDescription: 'Kupuj i Pomagaj! - Robiąc zakupy w internecie, płacisz tyle co zawsze i wspierasz osoby niepełnosprawne!',
      shareHashtags: [
        "kupujipomagaj",
        "pomagaj",
        "cashback"
      ].join(','),
      shareHashtag: 'kupujipomagaj',
      copyText: 'Kopiuj',
      copyTextTimeout: null,
    }
  },
  computed: {
    shareUrl() {
      // Warning: coupled with backend in core/models.py (TODO: move to backend
      // computed property?)
      return `${appConfig.frontendUrl}/podopieczni/${this.child.slug}/udostepnij`;
    },
    landingPageUrl() {
      return appConfig.homepageUrl
    },
    messengerLink() {
      // fb-messenger://share/?link= https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fsharing%2Freference%2Fsend-dialog&app_id=123456789
      // @ts-ignore: TODO
      return `fb-messenger://share?link=${encodeURIComponent(this.shareUrl)}`;
    },
    twitterShareText() {
      // https://twitter.com/intent/post?text=Kupuj%20i%20Pomagaj!&url=https%3A%2F%2Fthinkpad.tail0a4ec.ts.net%2Fpodopieczni%2Faleksa-kowalska%2Fudostepnij&hashtags=kupujipomagaj%2Cpomagaj%2Ccashback&=
      // @ts-ignore: TODO
      return `${this.shareDescription} ${this.shareUrl} ${this.shareHashtags}`;
    }
  },
  mounted() {
    // @ts-ignore: TODO
    window.Sharer.init();
  }
})
